import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageKey } from '@core';

@Injectable({ providedIn: 'root' })
export class DashboardMessagesStorage {
  private readonly dismissedUpdateVersionSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(
    this.readDismissedUpdateVersion()
  );
  private readonly dismissedRedCardIdsSubject: BehaviorSubject<ReadonlySet<string>> = new BehaviorSubject<
    ReadonlySet<string>
  >(new Set<string>());

  readonly dismissedUpdateVersion$: Observable<string | null> = this.dismissedUpdateVersionSubject.asObservable();
  readonly dismissedRedCardIds$: Observable<ReadonlySet<string>> = this.dismissedRedCardIdsSubject.asObservable();

  dismissUpdate(version: string): void {
    this.dismissedUpdateVersionSubject.next(version);
    localStorage.setItem(LocalStorageKey.DashboardDismissedUpdateVersion, version);
  }

  dismissRedCard(penaltyId: string): void {
    const next: Set<string> = new Set<string>(this.dismissedRedCardIdsSubject.value);
    next.add(penaltyId);
    this.dismissedRedCardIdsSubject.next(next);
  }

  private readDismissedUpdateVersion(): string | null {
    return localStorage.getItem(LocalStorageKey.DashboardDismissedUpdateVersion);
  }
}
